import { render, staticRenderFns } from "./BlockEditEditableText.vue?vue&type=template&id=c5c3c048"
import script from "./BlockEditEditableText.vue?vue&type=script&lang=js"
export * from "./BlockEditEditableText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports